import { Component, DestroyRef, OnInit, ChangeDetectionStrategy, inject } from '@angular/core'
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ShortcodeService } from '@app/services/shortcode/shortcode.service'
import { Router } from '@angular/router'
import { LabelDirective } from '../../domains/ui/directives/label/label.directive'
import { InputDirective } from '../../domains/ui/directives/input/input.directive'
import { ButtonDirective } from '../../domains/ui/directives/button/button.directive'

@Component({
    selector: 'app-home',
    templateUrl: './home.page.html',
    styleUrls: ['./home.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LabelDirective, ReactiveFormsModule, InputDirective, ButtonDirective],
})
export class HomePage implements OnInit {
    private readonly destroy = inject(DestroyRef)
    private readonly shortcodeService = inject(ShortcodeService)
    private readonly router = inject(Router)


    public clientShortcode: FormControl<string>
    public loading: boolean = false

    public ngOnInit(): void {
        this.clientShortcode = new FormControl<string>('', {
            nonNullable: true,
            validators: [
                Validators.required,
                Validators.pattern(/^[A-Z0-9]{6}$/),
            ],
        })

        this.clientShortcode.valueChanges
            .pipe(takeUntilDestroyed(this.destroy))
            .subscribe((value) => this.clientShortcode.setValue(value.toUpperCase(), { emitEvent: false }))
    }

    public async continue(): Promise<void> {
        if (this.clientShortcode.invalid) {
            return
        }

        this.loading = true
        const shortcode = this.clientShortcode.value

        if (await this.shortcodeService.getClientByShortcode(shortcode)) {
            await this.router.navigate(['/client', shortcode])
        }
    }
}
